/**
 * Shared date-DISPLAY formatting (tables, read-only views, exports).
 * Indian date convention: dd/mm/yyyy.
 *
 * Do NOT use this for values bound to a native <input type="date"> — those
 * require yyyy-mm-dd regardless of display locale (an HTML/browser
 * requirement, not a choice this app makes). Use `toISODateInput` for that.
 */
export const formatDateDMY = (d: unknown, fallback = '—'): string => {
  if (!d) return fallback;
  const dt = new Date(String(d));
  if (isNaN(dt.getTime())) return fallback;
  const day   = String(dt.getUTCDate()).padStart(2, '0');
  const month = String(dt.getUTCMonth() + 1).padStart(2, '0');
  const year  = dt.getUTCFullYear();
  return `${day}/${month}/${year}`;
};

/** yyyy-mm-dd, for populating a native <input type="date"> value. */
export const toISODateInput = (d: unknown): string => {
  if (!d) return '';
  const dt = new Date(String(d));
  return isNaN(dt.getTime()) ? '' : dt.toISOString().slice(0, 10);
};
